import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import bus from '../services/bus'
import { CONTENT_CHANGED, CONTENT_LEAVE } from '../constants/content'
import ContentService from '../services/content'
import { connect } from 'react-redux'
import { __ } from '../services/translate'
import { selectLicenceNumbers } from '../utils/selectors/content'

class Breadcrumbs extends Component {
  state = {
    breadcrumbs: []
  }

  regenerateBreadcrumbs = () => {
    this.setState({
      breadcrumbs: ContentService.generateBreadcrumbs(
        this.props.selectedLanguageSlug,
        this.props.sections,
        this.props.articles,
        {
          vehicleType: this.props.selectedVehicleType,
          country: this.props.selectedCountry,
          userLicences: this.props.userLicences,
        }
      )
    })
  }

  resetBreadcrumbs = () => {
    this.setState({
      breadcrumbs: []
    })
  }

  componentDidMount() {
    // regenerate breadcrumbs after url change
    bus.on(CONTENT_CHANGED, this.regenerateBreadcrumbs)
    bus.on(CONTENT_LEAVE, this.resetBreadcrumbs)
  }

  componentWillUnmount() {
    bus.removeListener(CONTENT_CHANGED, this.regenerateBreadcrumbs)
    bus.removeListener(CONTENT_LEAVE, this.resetBreadcrumbs)
  }

  render() {
    const { breadcrumbs } = this.state
    if (breadcrumbs.length < 1) {
      return null
    }

    return (
      <Fragment>
        <Container>
          {breadcrumbs.map((breadcrumb, i) => (
            breadcrumb.last ? (
              <span key={i}>
          {breadcrumb.name}
        </span>
            ) : (
              <Fragment key={i}>
                <Link to={breadcrumb.url}>
                  {breadcrumb.name}
                </Link>
                <span>/</span>
              </Fragment>
            )
          ))}
        </Container>
        {
          breadcrumbs.length >= 2 && (
            <BackButtonContainer>
              <Link to={breadcrumbs[breadcrumbs.length - 2].url}>
                <i className="fa fa-caret-left"/>
                {__('Zpět')}
              </Link>
            </BackButtonContainer>
          )
        }
      </Fragment>
    )
  }
}

const Container = styled.div`
  padding: .5rem;
  border-bottom: 1px solid ${({ theme }) => theme.gray};
  margin-bottom: 1rem;
  
  span {
    color: #999;
  }
  
  span, a {
     padding: 0 .4rem;
  }
`

const BackButtonContainer = styled.div`
  padding: .3rem 0 .3rem .9rem;
  margin-top: -1rem;
  border-bottom: 1px solid ${({ theme }) => theme.gray};
  
  i {
    margin-right: .5rem;
  }
`

const mapStateToProps = (state) => ({
  sections: state.content.sections,
  articles: state.content.articles,
  selectedLanguageSlug: state.locale.selectedLanguage.slug,
  selectedVehicleType: state.user.selectedVehicleType,
  selectedCountry: state.locale.selectedCountry,
  userLicences: selectLicenceNumbers(state.user),
})

export default connect(mapStateToProps)(Breadcrumbs)
